import { render, staticRenderFns } from "./ResumeTab.vue?vue&type=template&id=9af02fc2&"
import script from "./ResumeTab.vue?vue&type=script&lang=js&"
export * from "./ResumeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports